/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminGetHistoricalBalancesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AdminGetHistoricalBalancesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const adminGetHistoricalBalances = (request:AdminGetHistoricalBalancesRequest, options?: CashRequestOptions) => post<AdminGetHistoricalBalancesRequest, AdminGetHistoricalBalancesResponse>("/2.0/cash/admin-get-historical-balances", request, {...options, rejectOnError: true })